import service from '../utils/fetch';
import { stringify } from 'qs';

export async function queryActivityDetail(params) {
    return service('/zy/m/t/activity/winter/getActivityDetail', {
        method: 'GET',
        params,
    });
}

export async function queryTeacherJoinCamp(data) {
    return service('/zy/m/t/activity/winter/hasJoin', {
        method: 'POST',
        data: stringify(data),
    });
}

export async function queryStudentJoinCamp(data) {
    return service('/zy/m/s/activity/winter/join', {
        method: 'POST',
        data: stringify(data),
    });
}

export async function queryClassList(data) {
    return service('/zy/m/t/activity/winter/getClazzs', {
        method: 'POST',
        data: stringify(data),
    });
}



// WEBPACK FOOTER //
// ./src/views/winter-camp/api/introduce.js